"use client";

import React from "react";

import { EmHouseIcon } from "@/components/icons-lib";

import { ClusterSelectionSummary } from "./cluster-selection/cluster-selection-summary";
import { SCHOOL_CLUSTER_SUMMARY_DICTIONARY } from "./school-cluster-summary.constants";

interface SchoolClusterSummaryProps {
  schoolsCount: number;
}

const SchoolClusterSummaryComponent: React.FC<SchoolClusterSummaryProps> = ({ schoolsCount }) => {
  return (
    <ClusterSelectionSummary
      metrics={[
        {
          value: schoolsCount,
          label: SCHOOL_CLUSTER_SUMMARY_DICTIONARY.schools,
          icon: <EmHouseIcon />,
        },
      ]}
    />
  );
};

export const SchoolClusterSummary = React.memo(SchoolClusterSummaryComponent);
